import { useTranslation } from "react-i18next";

import TeamMemberCard from "../../components/TeamMemberCard/TeamMemberCard";

import "./TeamMembers.css";

const TeamMembers = () => {
	const { t } = useTranslation();
	const members = t("team.full.teamMembers.members", { returnObjects: true });

	return (
		<div className="team-members-bg">
			<h1 className="team-members-title">{t("team.full.teamMembers.title")}</h1>

			<div className="team-members-container">
				{members.map((member, index) => (
					<TeamMemberCard
						key={index}
						data={{
							id: index,
							image: member["image"],
							alt: member["alt"],
							name: member["name"],
							title: member["title"],
							position: member["position"],
							techStack: member["techStack"],
						}}
					/>
				))}
			</div>
		</div>
	);
};

export default TeamMembers;
